import {React } from "react";
import { Link } from "react-router-dom";

//search component
const Search = ({bannerData})  => {

    return(
        <>
        {bannerData.hm_update_check ?
        <div className="card-alert">
            <Link className="btn" to={bannerData.hm_update_link} target="_blank">
                {bannerData.hm_update_label ? bannerData.hm_update_label : "Click Here" }</Link>
            <span className="body">{bannerData.hm_update_text ? bannerData.hm_update_text : "Apps update is available now"}</span>
        </div>
        :"" }
            
        </>
    );
}

export default Search;